import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { motion, type Variants } from 'framer-motion';
import Lottie from 'lottie-react';
import { Button } from '@/components/atoms/Button';
import { ROUTES } from '@/constants/routes';
import successAnimation from '@/assets/lottie/success.json';
import styles from './AccountDeletedPage.module.scss';

// Coreografía escalonada: cada elemento entra en secuencia
// (Lottie → título → texto → botón).
const container: Variants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.22, delayChildren: 0.15 },
  },
};

const item: Variants = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: 'easeOut' } },
};

/**
 * Página de despedida tras eliminar la cuenta. Contenido centrado con la
 * animación Lottie de éxito (la misma de la pantalla de resultados) y una
 * entrada coreografiada. Es pública (el usuario ya no tiene sesión).
 */
export function AccountDeletedPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.accountDeleted}>
      <motion.div
        className={styles.accountDeleted__shell}
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.div className={styles.accountDeleted__lottie} variants={item}>
          <Lottie animationData={successAnimation} loop={false} autoplay />
        </motion.div>
        <motion.h1 className={styles.accountDeleted__title} variants={item}>
          {t('auth.accountDeleted.title')}
        </motion.h1>
        <motion.p className={styles.accountDeleted__text} variants={item}>
          {t('auth.accountDeleted.message')}
        </motion.p>
        <motion.div className={styles.accountDeleted__cta} variants={item}>
          <Button
            variant="primary"
            size="lg"
            fullWidth
            onClick={() => navigate(ROUTES.AUTH.LOGIN, { replace: true })}
          >
            {t('auth.accountDeleted.cta')}
          </Button>
        </motion.div>
      </motion.div>
    </div>
  );
}

export default AccountDeletedPage;
